import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import moment from 'moment';
import { interval, Subscription } from 'rxjs';
import { SyncMIResponse } from 'src/app/core/interfaces/magicInfoResponse';
import { SyncMagicinfoService } from 'src/app/core/services/sync-magicinfo.service';

@Component({
    selector: 'app-last-date-sync',
    templateUrl: './last-date-sync.component.html',
    styleUrls: ['./last-date-sync.component.scss'],
    standalone: false
})
export class LastDateSyncComponent implements OnInit, OnDestroy {
  @Input('date') date: string;
  @Input('miId') miId: string;
  @Output() syncStatus: EventEmitter<string> = new EventEmitter<string>();

  constructor(private syncMagicinfoService: SyncMagicinfoService) {}

  intervalSubscription: Subscription;

  momentAgo: string;

  group: SyncMIResponse;

  updateDate(date: Date | null) {
    // console.log("this.syncMagicinfoService.syncRes", this.syncMagicinfoService.syncRes, this.miId)
    if (this.syncMagicinfoService.syncRes.length > 0) {
      this.group = this.syncMagicinfoService.syncRes.find(
        (g) => g.device_group_id == this.miId
      );
      if (this.group) {
        // if (this.group.syncStatus == 'progress') {
        //   this.momentAgo = 'in progress'
        // } else {
        if (this.group.lastDateSync && this.group.syncStatus == 'success') {
          // A manual sync from this page, unless the server reports a newer (automatic) one.
          const manualSync = new Date(this.group.lastDateSync);
          if (!date || manualSync > date) {
            date = manualSync;
          }
        }
        if(date){
          this.momentAgo = moment(date).fromNow();
        }else{
          this.momentAgo = this.group.syncStatus;
        }
        // }
        this.syncStatus.emit(this.group.syncStatus);
      } else {
        if (date) {
          this.momentAgo = moment(date).fromNow();
        }else{
          this.momentAgo = 'never sync'
        }
      }
    } else {
      if (date) {
        this.momentAgo = moment(date).fromNow();
      }else{
        this.momentAgo = 'never sync'
      }
    }
    // console.log("ago", this.momentAgo)
  }

  ngOnInit(): void {
    // The date input is read on every tick, so a newer last sync shows without reloading the page.
    const source = interval(1000);
    this.intervalSubscription = source.subscribe(() => {
      this.updateDate(this.date ? new Date(this.date) : null);
    });
  }
  ngOnDestroy() {
    this.intervalSubscription?.unsubscribe();
  }
}
